<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="代理ID">
            <template slot="label">
              <I18Lang id="proxycust4" defaultText="姓名/用户ID/交易账号" />
            </template>
            <el-input
              v-model="queryForm.username"
              :placeholder="$t('proxycust128')"
            ></el-input>
          </el-form-item>
          <el-form-item label="领取时间">
            <template slot="label">
              <I18Lang id="text49" defaultText="领取时间" />
            </template>
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              @change="dateChange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"
            ></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryChange">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div
            class="btn kg-refresh btn-query-refresh"
            @click="resetChange"
          ></div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table" v-loading="isTableLoading">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="180" label="流水号" prop="id">
            <template slot="header">
              <I18Lang id="text14" defaultText="流水号" />
            </template>
          </el-table-column>

          <el-table-column width="150" label="姓名" prop="username">
            <template slot="header">
              <I18Lang id="proxycust13" defaultText="姓名" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.username : "" }}
            </template>
          </el-table-column>

          <el-table-column width="150" label="用户ID" prop="account_id">
            <template slot="header">
              <I18Lang id="proxymoney89" defaultText="用户ID" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.account_id : "" }}
            </template>
          </el-table-column>

          <el-table-column width="150" label="交易账号" prop="account_id">
            <template slot="header">
              <I18Lang id="proxycust26" defaultText="交易账号" />
            </template>
            <template slot-scope="{ row }">
              {{ row.user ? row.user.account_no : "" }}
            </template>
          </el-table-column>

          <el-table-column width="150" label="上级代理" prop="username">
            <template slot="header">
              <I18Lang id="text51" defaultText="上级代理" />
            </template>
            <template slot-scope="{ row }">
              {{ row.agent3user ? row.agent3user.username : "" }}
            </template>
          </el-table-column>

          <el-table-column label="入金金额（MEQ）" prop="recharge_amount">
            <template slot="header">
              <I18Lang id="text72" defaultText="入金金额（MEQ）" />
            </template>
          </el-table-column>

          <el-table-column label="注入流动性净值" prop="net_amount">
            <template slot="header">
              <I18Lang id="text73" defaultText="注入流动性净值" />
            </template>
          </el-table-column>

          <el-table-column label="奖励比例" prop="settle_rate">
            <template slot="header">
              <I18Lang id="text74" defaultText="奖励比例" />
            </template>
          </el-table-column>

          <el-table-column label="天数" prop="day">
            <template slot="header">
              <I18Lang id="text75" defaultText="天数" />
            </template>
          </el-table-column>

           <el-table-column label="激活日期" prop="create_time">
            <template slot="header">
              <I18Lang id="text109" defaultText="激活日期" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="激活金额（MEQ-A）" prop="opx_t">
            <template slot="header">
              <I18Lang id="text76" defaultText="激活金额（MEQ-A）" />
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <el-pagination
            background
            :page-size="queryForm.size"
            @current-change="pageChange"
            layout="prev, pager, next"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr, serverUrl } from '@utils'
import { mapState } from 'vuex'
import cookie from '@utils/cookie'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    return {
      serverUrl,
      dateTime: '',
      queryForm: {
        username: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 15
      },
      writeType: '',
      currentData: {},
      isTableLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      statusList: {
        1: i18n.t('text43'),
        2: i18n.t('text44')
      }
    }
  },
  created () {
    this.getRecord()
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/opxTRecords?${formateObjToParamStr(params)}`
      )
    },
    getRecord () {
      this.isTableLoading = true
      this.$http
        .post('/api/agent/opxTRecords', this.queryForm)
        .then((result) => {
          this.tableData = result
        })
        .finally(() => {
          this.isTableLoading = false
        })
    },
    queryChange () {
      this.pageChange(1)
    },
    resetChange () {
      Object.keys(this.queryForm).map((item) => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryChange()
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
.page-main {
  .box-card-header {
    padding-bottom: 10px;

    .right {
      .statistics {
        font-size: 16px;
        color: #2a2a2a;
        letter-spacing: 0;
        line-height: 32px;
        vertical-align: top;
        margin-top: 5px;

        .num {
          color: #e61816;
        }
      }
    }
  }

  .box-card-content {
    .query {
      display: flex;
      justify-content: space-between;

      .btn-red {
        background: #e61816;
        border-color: #e61816;
      }
    }

    .table {
      ::v-deep .el-table {
        thead {
          tr,
          th {
            background: #f4f4f4;
            text-align: center;
          }
        }

        td {
          font-size: 14px;
          padding: 16px 0;
          text-align: center;
        }
      }

      .page {
        padding-top: 24px;
        text-align: right;

        ::v-deep .el-pager {
          .active {
            background: #e61816;
          }
        }
      }
    }
  }
}

.bank-info {
  p {
    margin-bottom: 10px;
  }
}

.operat-group {
  .operat-item {
    display: inline-block;
    margin-right: 15px;
    font-size: 14px;
    color: #0f75bd;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-decoration: underline;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}
.page {
  position: relative;
  .sum {
    position: absolute;
    left: 0;
    font-size: 14px;
    color: #fff;
  }
}
</style>
